/**
 * Rôles de gestion métier (hors client et agent commercial).
 * Un compte agent commercial pur ne doit pas les avoir.
 */
export const MANAGEMENT_ROLES = [
  'admin',
  'driver',
  'chauffeur',
  'business',
  'businessOwner',
  'owner',
  'rental',
  'rental_owner',
  'loueur',
  'cash_agent'
];

export function normalizeRoles(profile) {
  if (!profile) return [];
  if (Array.isArray(profile.roles) && profile.roles.length) {
    return profile.roles;
  }
  if (profile.role) {
    return [profile.role];
  }
  return ['user'];
}

export function hasManagementRoleFromRoles(roles = []) {
  return roles.some((role) => MANAGEMENT_ROLES.includes(role));
}

/** Agent commercial (rôle actif ou dossier en cours / traité). */
export function isCommercialAgentProfile(profile) {
  if (!profile) return false;
  const roles = normalizeRoles(profile);
  if (roles.includes('commercial_agent')) return true;
  const status = profile.agentApplicationStatus;
  return Boolean(
    profile.commercialAgentCode ||
      status === 'pending_review' ||
      status === 'active' ||
      status === 'rejected' ||
      status === 'deactivated'
  );
}

/** Compte centré agent commercial — pas d’autre espace de gestion. */
export function isCommercialAgentOnlyProfile(profile) {
  return (
    isCommercialAgentProfile(profile) &&
    !hasManagementRoleFromRoles(normalizeRoles(profile))
  );
}
